// extracted by mini-css-extract-plugin
export var formContainer = "_jf-0";
export var message = "_jf-1";